export enum AmmendNearMissLoadingState {
    loadingNearMiss = 'ObservationPage.LoadingNearMiss',
    savingChanges = 'ObservationPage.SavingChanges',
    submittingCompletion = 'ObservationPage.SubmittingCompletionNearMiss',
    submittingReOpening = 'ObservationPage.SubmittingReOpeningNearMiss'
}